/* Titan13 — instant gallery swap for the STYLE row.
 *
 * WHY THIS FILE DOES ANYTHING AT ALL
 * ----------------------------------
 * It used to be vestigial: it bound a sold-out class on DOMContentLoaded and
 * shopify:section:load, neither of which fires on a variant change, and its guard
 * tested `input.classList.contains('disabled')` — a class Horizon never sets. The
 * sold-out state is server-rendered in Liquid, so nothing depended on it running.
 *
 * ⚠️ THE PICKER WAS SLOW FOR ONE REASON: Horizon's variant-picker.js fetches the WHOLE
 * product page on every variant change (`/products/<handle>?option_values=…`, no
 * section_id), DOMParser's it, then morphs. Measured on T1: 774,134 bytes, and the
 * image cannot appear until it lands. Style row measured at 650 ms.
 *
 * But every product image is ALREADY in the DOM as <slideshow-slide>, and
 * <slideshow-component> exposes a public select(index). So the picture is a LOCAL
 * operation. We do it on the click, synchronously, and let Horizon's fetch continue in
 * the background for price / stock / Add-to-cart.
 *
 * ⚠️ Lives here, not in bundle-selector.js, because bundle-selector only loads where a
 * bundle-group block is mounted — product.locked.json has none, which is exactly the
 * template Chris found slow. variant-main-picker.liquid loads THIS on every product page.
 *
 * ⚠️ Matched on FILENAME (data-titan-media), never a full URL: the gallery renders its
 * own width/crop params, so the src strings never match end to end.
 * ⚠️ Capture phase: Horizon's own change handler starts the fetch, and we want the
 * repaint queued before that work begins.
 */
(function () {
  'use strict';

  function slides() {
    var g = document.querySelector('media-gallery');
    return g ? { g: g, list: g.querySelectorAll('slideshow-slide') } : null;
  }

  function show(file) {
    if (!file) return false;
    var s = slides();
    if (!s) return false;
    var comp = s.g.querySelector('slideshow-component');
    if (!comp || typeof comp.select !== 'function') return false;
    for (var i = 0; i < s.list.length; i++) {
      var img = s.list[i].querySelector('img');
      var src = img && (img.currentSrc || img.getAttribute('src') || '');
      if (src && src.split('?')[0].split('/').pop() === file) {
        comp.select(i);
        return true;
      }
    }
    return false;
  }

  function onChange(e) {
    var el = e.target;
    if (!el || !el.closest) return;
    var input = el.closest('[data-titan-media]');
    if (!input || !input.closest('variant-picker')) return;
    show(input.getAttribute('data-titan-media'));
  }

  document.addEventListener('change', onChange, true);
  document.addEventListener('click', onChange, true);
})();

/* Titan13 — the SECOND option row's art follows the FIRST row's selection, instantly.
 *
 * WHAT WAS WRONG (Chris, 2026-10-03, Kaiju T13 2.0): the EDITION row painted the BLUE
 * Standard / BLUE Deluxe pictures whichever colour was selected, because the Liquid
 * scan took the first variant matching "Standard (figure only)" and that is always the
 * Blue one. snippets/variant-main-picker.liquid now resolves each row against the other
 * rows' CURRENT selection, so the server render is right.
 *
 * WHY THIS HALF EXISTS ANYWAY. A variant click does not re-render locally — Horizon
 * refetches the whole product page (774,134 bytes on T1) and morphs it in. Until it
 * lands the second row still shows the old colour's art. Same ~650 ms staleness the
 * gallery swap above was written to kill, same fix: do it locally on the click and let
 * the fetch catch up.
 *
 * ⚠️ Driven by the server-emitted [data-titan-swatch-map] blob (variant option tuple ->
 * swatch url at width 224). The url is byte-identical to the one the Liquid renders, so
 * the swap is a cache hit and the morph that follows is a no-op — see
 * morph.js:322-326's unchanged-src guard. Never rebuild the url here.
 * ⚠️ Capture phase AND an explicit override of the clicked input: on `click` the radio's
 * .checked is not yet true, so reading the DOM alone paints one selection behind.
 * ⚠️ object-fit/-position only ride along when the block is on `auto` fit — an explicit
 * fit setting belongs to whoever set it.
 * ⚠️ Fails silent and whole: no map, no match, no <img>, and the row simply keeps what
 * the server rendered. That is the pre-2026-10-03 behaviour, never a blank swatch.
 */
(function () {
  'use strict';

  var SEP = '\u0000';
  var RADIO = 'input[type="radio"][data-input-id]';

  function swatchMap(picker) {
    var el = picker.querySelector('script[data-titan-swatch-map]');
    if (!el) return null;
    if (el.__titanMap !== undefined) return el.__titanMap;
    var parsed = null;
    try {
      parsed = JSON.parse(el.textContent);
    } catch (err) {
      parsed = null;
    }
    if (parsed && parsed.v) {
      var ix = {};
      for (var i = 0; i < parsed.v.length; i++) {
        var row = parsed.v[i];
        var o = row.o || [];
        var key = [o[0] == null ? '' : o[0], o[1] == null ? '' : o[1], o[2] == null ? '' : o[2]].join(SEP);
        if (ix[key] === undefined) ix[key] = row;
      }
      parsed.index = ix;
    } else {
      parsed = null;
    }
    el.__titanMap = parsed;
    return parsed;
  }

  /* "2-0" -> 2. Position is 1-based and matches variant.option1/2/3. */
  function position(input) {
    var id = input.getAttribute('data-input-id') || '';
    var p = parseInt(id.split('-')[0], 10);
    return p >= 1 && p <= 3 ? p : 0;
  }

  function apply(picker, clicked) {
    var map = swatchMap(picker);
    if (!map) return;
    var inputs = picker.querySelectorAll(RADIO);
    var selected = ['', '', ''];
    var i, p;

    for (i = 0; i < inputs.length; i++) {
      p = position(inputs[i]);
      if (p && inputs[i].checked) selected[p - 1] = inputs[i].value;
    }
    if (clicked) {
      p = position(clicked);
      if (p) selected[p - 1] = clicked.value;
    }

    for (i = 0; i < inputs.length; i++) {
      p = position(inputs[i]);
      if (!p) continue;
      var want = [selected[0], selected[1], selected[2]];
      want[p - 1] = inputs[i].value;
      var row = map.index[want.join(SEP)];
      if (!row || !row.u) continue;
      var label = inputs[i].parentNode;
      var img = label && label.querySelector ? label.querySelector('img.titan-swatch__img') : null;
      if (!img) continue;
      if (img.getAttribute('src') !== row.u) img.setAttribute('src', row.u);
      if (map.auto && row.f) {
        var dot = img.parentNode;
        if (dot && dot.style) {
          dot.style.setProperty('--titan-fit', row.f);
          dot.style.setProperty('--titan-pos', row.p || 'center');
        }
      }
    }
  }

  function onPick(e) {
    var el = e.target;
    if (!el || !el.closest) return;
    var input = el.closest(RADIO);
    if (!input) return;
    var picker = input.closest('variant-picker');
    if (picker) apply(picker, input);
  }

  function syncAll() {
    var pickers = document.querySelectorAll('variant-picker');
    for (var i = 0; i < pickers.length; i++) apply(pickers[i], null);
  }

  document.addEventListener('change', onPick, true);
  document.addEventListener('click', onPick, true);
  document.addEventListener('DOMContentLoaded', syncAll);
  document.addEventListener('shopify:section:load', syncAll);
  if (document.readyState !== 'loading') syncAll();
})();
